import { Label } from "@/components/ui/label";

export function AssignmentSection({ formData, handleChange, properties, agents, user, isEdit }) {
  return (
    <>
      {/* Property */}
      <div>
        <Label htmlFor="property_id">Interested Property (Optional)</Label>
        <select
          id="property_id"
          name="property_id"
          data-testid="lead-property-select"
          value={formData.property_id}
          onChange={handleChange}
          className="mt-1 h-11 w-full rounded-sm border border-slate-200 bg-white px-3 text-sm focus:border-blue-900 focus:ring-1 focus:ring-blue-900"
        >
          <option value="">None</option>
          {properties.map((property) => (
            <option key={property.id} value={property.id}>
              {property.title} - ₹{property.price.toLocaleString('en-IN')}
            </option>
          ))}
        </select>
      </div>

      {/* Source and Assignment */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <Label htmlFor="source">Source *</Label>
          <select
            id="source"
            name="source"
            data-testid="lead-source-select"
            value={formData.source}
            onChange={handleChange}
            className="mt-1 h-11 w-full rounded-sm border border-slate-200 bg-white px-3 text-sm focus:border-blue-900 focus:ring-1 focus:ring-blue-900"
            required
          >
            <option value="website">Website</option>
            <option value="referral">Referral</option>
            <option value="advertisement">Advertisement</option>
            <option value="social_media">Social Media</option>
            <option value="walk_in">Walk-in</option>
          </select>
        </div>

        {(user.role === "admin" || user.role === "team_leader") && (
          <div>
            <Label htmlFor="assigned_to">Assign to Agent / TL</Label>
            <select
              id="assigned_to"
              name="assigned_to"
              data-testid="lead-agent-select"
              value={formData.assigned_to}
              onChange={handleChange}
              className="mt-1 h-11 w-full rounded-sm border border-slate-200 bg-white px-3 text-sm focus:border-blue-900 focus:ring-1 focus:ring-blue-900"
            >
              <option value="">Unassigned</option>
              {agents.map((agent) => (
                <option key={agent.id} value={agent.id}>
                  {agent.full_name} ({agent.role === 'team_leader' ? 'TL' : 'Agent'})
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      {/* Status and Priority */}
      {isEdit && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <Label htmlFor="status">Pipeline Status</Label>
            <select
              id="status"
              name="status"
              data-testid="lead-status-select"
              value={formData.status}
              onChange={handleChange}
              className="mt-1 h-11 w-full rounded-sm border border-slate-200 bg-white px-3 text-sm focus:border-blue-900 focus:ring-1 focus:ring-blue-900"
            >
              <option value="new_web_lead">New Web Lead</option>
              <option value="assigned">Assigned</option>
              <option value="attempted_contact">Attempted Contact</option>
              <option value="contacted">Contacted</option>
              <option value="requirement_gathered">Requirement Gathered</option>
              <option value="pitched">Pitched</option>
              <option value="site_visit_scheduled">Site Visit Scheduled</option>
              <option value="site_visit_completed">Site Visit Completed</option>
              <option value="in_negotiation">In Negotiation</option>
              <option value="closed_won">Closed - Won</option>
              <option value="closed_lost">Closed - Lost</option>
            </select>
          </div>
          <div>
            <Label htmlFor="priority">Priority</Label>
            <select
              id="priority"
              name="priority"
              data-testid="lead-priority-select"
              value={formData.priority}
              onChange={handleChange}
              className="mt-1 h-11 w-full rounded-sm border border-slate-200 bg-white px-3 text-sm focus:border-blue-900 focus:ring-1 focus:ring-blue-900"
            >
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
              <option value="urgent">Urgent</option>
            </select>
          </div>
        </div>
      )}
    </>
  );
}
